import * as React from "react";
import aboutJpeg from "../../resources/images/about.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF } from "@fortawesome/free-brands-svg-icons";
import { faPinterestP } from "@fortawesome/free-brands-svg-icons";
import { faTwitter } from "@fortawesome/free-brands-svg-icons";
import "../../styles/about.css";

const About: React.FC = () => {
  return (
    <section id="about" className="body-section">
      <div className="container">
        <h2 className="text-center section-title">About</h2>
        <hr />
        <p className="justify">
          Founded in 2007, Tribeca has over 10 years of experience in interior
          and exterior design with an impressive list of successful projects. We
          gained the trust of our clients with the help of our personalized
          approach and the unique way of combining multiple design disciplines
          to meet the demands of their projects.
        </p>
        <div className="row">
          <div className="col-md-6">
            {/* <div style={{ height: "100%", display: "flex", alignItems: "center", flexDirection: "column", justifyContent: "center" }}> */}
            <div>
              <div className="about-image-box">
                <img src={aboutJpeg} className="about-image" alt="about" />
                <div className="about-image-overlay">
                  <ul className="social">
                    <a
                      href="https://www.facebook.com/studiotribeca"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <li className="social-li facebookAndLinkedIn">
                        <FontAwesomeIcon
                          width="15"
                          height="15"
                          color="white"
                          icon={faFacebookF}
                        />
                      </li>
                    </a>
                    <a
                      href="https://twitter.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <li className="social-li twitter">
                        <FontAwesomeIcon
                          width="15"
                          height="15"
                          color="white"
                          icon={faTwitter}
                        />
                      </li>
                    </a>
                    <a
                      href="https://www.pinterest.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <li className="social-li pinterest">
                        <FontAwesomeIcon
                          width="15"
                          height="15"
                          color="white"
                          icon={faPinterestP}
                        />
                      </li>
                    </a>
                  </ul>
                </div>
              </div>

              <p className="text-center">
                <i>Suren Gavaryan - The Founder of Tribeca</i>
              </p>
            </div>
          </div>
          <div className="col-md-6">
            <h2 className="title">
              <b>Architecture</b>
            </h2>
            <p className="justify">
              Our detail-oriented team will plan every single part of the
              arrangement of any kind of building or structure, residential and
              commercial buildings. The architectural features include, but are
              not limited to, the general design and style, the textures of the
              building materials, the landscaping, the style of all the elements
              and other fixtures.
            </p>
            <h2 className="title">
              <b>Interior</b>
            </h2>
            <p className="justify">
              We aim to create positive experiences for our clients by
              considering not only the technical but also the functional
              requirements. The process consists of identification, thorough
              research, and providing creative solutions for the interior
              spaces. From simple to complex concepts, our specialists will
              offer the ideal combination of color, texture, patterns, and light
              to create an enjoyable and healthy environment.
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <p className="justify">
              Our goal is to fulfill even the bravest desires of our clients and
              bring them to life to satisfy their needs. We believe that perfect
              design is the result of truly understanding the needs of every
              client and providing solutions that will transcend their
              expectations.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
